<template>

  <div class="min-w-screen min-h-screen bg-slate-100 flex items-center p-5 lg:p-20 overflow-hidden relative">
    <div
        class="flex-1 min-h-full min-w-full rounded-3xl bg-white shadow-xl p-10 lg:p-20 text-gray-800 relative md:flex items-center text-center md:text-left">
      <div class="w-full md:w-1/2">
        <div class="mb-10 lg:mb-20">

        </div>
        <div class="mb-10 md:mb-20 text-gray-600 font-light">
          <h1 class="font-black uppercase text-3xl lg:text-5xl text-yellow-500 mb-10">Pareces estar perdido!</h1>
          <p>La página que estás buscando no está disponible.</p>
          <p>Intente buscar de nuevo o use el botón volver a continuación</p>
        </div>
        <div class="mb-20 md:mb-0">
          <button
              class="text-lg font-light outline-none focus:outline-none transform transition-all hover:scale-110 text-yellow-500 hover:text-yellow-600">
            <i class="mdi mdi-arrow-left mr-2"></i>
            <router-link to="/">Ir home</router-link>
          </button>
        </div>
      </div>
      <div class="w-full md:w-1/2 text-center">

      </div>
    </div>
    <div
        class="w-64 md:w-96 h-96 md:h-full bg-green-600 bg-opacity-30 absolute -top-64 md:-top-96 right-20 md:right-32 rounded-full pointer-events-none -rotate-45 transform"></div>
    <div
        class="w-96 h-full bg-red-600 bg-opacity-20 absolute -bottom-96 right-64 rounded-full pointer-events-none -rotate-45 transform"></div>
  </div>

  <div class="flex items-end justify-end fixed bottom-0 right-0 mb-4 mr-4 z-10">
    <div>

    </div>
  </div>
</template>

<script>
/**
 Componente para mostrar página de error cuando una página no está disponible
 @component
 @nombre {string} ErrorPage
 @example
 <template>
 <ErrorPage />
 </template>
 */
export default {
  name: "ErrorPage",
};
</script>

<style>@import url(https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/5.3.45/css/materialdesignicons.min.css);</style>
